export default __webpack_public_path__ + "static/media/rarity-very-rare.681bd7e2.svg";